import includes from 'lodash/includes';

import {
  LINK_TYPE_INTERNAL,
  LINK_TYPE_EXTERNAL,
  LINK_TYPE_OVERLAY
} from 'zoomforth_codesbane_viewer/const/link_types.js';

export const isExternalLink = (appAction)=>
  appAction.type === LINK_TYPE_EXTERNAL;

export const doesOnlyNavToSubpage = (appAction)=> {
  return appAction.type === LINK_TYPE_INTERNAL 
    && appAction.subpageId 
    && !appAction.sectionId
    && !appAction.contentUuid;
};

export const doesOnlyNavToSection = (appAction)=> {
  return appAction.type === LINK_TYPE_INTERNAL 
    && appAction.subpageId 
    && appAction.sectionId
    && !appAction.contentUuid;
};

export const doesOpenOverlayContent = (appAction)=>
  appAction.type === LINK_TYPE_INTERNAL 
    && !!appAction.shouldOpenOverlay;

export const getATagProps = ({ type, ...appAction })=>{

  if (type === LINK_TYPE_EXTERNAL) {
    return {
      href: getExternalLinkUrl(appAction),
      target: getExternalLinkTarget(appAction)
    };
  }

  if (includes([LINK_TYPE_INTERNAL, LINK_TYPE_OVERLAY], type)) {
    return {
      href: getInternalLinkUrl(appAction),
      target: getInternalLinkTarget(appAction)
    };
  }

  throw new Error(`Unexpected action link type: ${type}`);

};

export const getUrl = ({ type, ...appAction })=> {
  if (type === LINK_TYPE_EXTERNAL) {
    return getExternalLinkUrl(appAction);
  }

  if (type === LINK_TYPE_INTERNAL) {
    return getInternalLinkUrl(appAction);
  }

  throw new Error(`Unexpected appAction type: ${type}`);
};


export const getTarget = ({ type, ...appAction })=> {
  if (type === LINK_TYPE_EXTERNAL) {
    return getExternalLinkTarget(appAction);
  }

  if (type === LINK_TYPE_INTERNAL) {
    return getInternalLinkTarget(appAction);
  }

  throw new Error(`Unexpected appAction type: ${type}`);
};


export const getExternalLinkUrl = (appAction)=>
  appAction.url;

export const getExternalLinkTarget = (appAction)=>
  appAction.target || '_blank';

export const doesOpenInNewTab = (appAction)=>
  appAction.target === '_blank';


export const getInternalLinkUrl = (appAction)=> {
  const {
    sectionId,
    subpageId,
    subpageSlug,
    contentUuid,
    shouldOpenOverlay
  } = appAction;
  // Support old subpages that do not have a slug by defaulting to the ID here.
  // As of 2020-06-26 the slug will be used instead of the ID for all new subpages.
  let hash = `#/subpage/${subpageSlug || subpageId}`;
  if (contentUuid) {

    if (shouldOpenOverlay) {
      hash += `/overlay/${contentUuid}`;
    } else {
      hash += `/content/${contentUuid}`;
    }

  } else if (sectionId) {
    hash += `/section/${sectionId}`;
  }

  return hash;
};

export const getDownloadableLinkUrl = (appAction)=> {
  const { subpageId, subpageSlug, contentUuid, } = appAction;

  return `#/subpage/${subpageSlug || subpageId}/download/${contentUuid}`;
};

export const getInternalLinkTarget = ()=>
  null;
